import { render, staticRenderFns } from "./DodatnaAktivnostDetails.vue?vue&type=template&id=44a11dc2&scoped=true&"
import script from "./DodatnaAktivnostDetails.vue?vue&type=script&lang=js&"
export * from "./DodatnaAktivnostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a11dc2",
  null
  
)

export default component.exports